/* Orlivia — zone produit
   Flèches, points et légende de la galerie ; pilules défilantes ; icônes SVG
   recolorées. Le carrousel reste celui du thème (Flickity) : on ne le remplace
   pas, on lui envoie l'événement « theme:image:change » qu'il écoute déjà, et
   on lit l'image affichée sur la classe « is-selected » qu'il pose lui-même. */
(function () {
  'use strict';

  if (window.__orliviaProduct) return;
  window.__orliviaProduct = true;

  /* ------------------------------------------------------------ galerie */

  function visibleSlides(slideshow) {
    var all = slideshow.querySelectorAll('[data-media-slide]');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.classList.contains('hide') || el.hasAttribute('hidden')) continue;
      if (!el.getAttribute('data-media-id')) continue;
      out.push(el);
    }
    return out;
  }

  function currentIndex(slides) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-selected')) return i;
    }
    return 0;
  }

  function selectMedia(slideshow, id) {
    slideshow.dispatchEvent(new CustomEvent('theme:image:change', { detail: { id: id } }));
  }

  function Gallery(root) {
    this.root = root;
    this.slideshow = root.querySelector('[data-product-slideshow]');
    if (!this.slideshow) return;
    this.dots = root.querySelector('[data-oi-gnav-dots]');
    this.caption = root.querySelector('[data-oi-caption]');
    this.bind();
    this.buildDots();
    this.sync();
    this.placeArrows();
    this.watch();
  }

  Gallery.prototype.bind = function () {
    var self = this;
    var arrows = this.root.querySelectorAll('[data-oi-gnav]');
    for (var i = 0; i < arrows.length; i++) {
      arrows[i].addEventListener('click', function (event) {
        event.preventDefault();
        var dir = this.getAttribute('data-oi-gnav') === 'prev' ? -1 : 1;
        var slides = visibleSlides(self.slideshow);
        if (slides.length < 2) return;
        var next = (currentIndex(slides) + dir + slides.length) % slides.length;
        selectMedia(self.slideshow, slides[next].getAttribute('data-media-id'));
      });
    }
  };

  Gallery.prototype.buildDots = function () {
    if (!this.dots) return;
    var self = this;
    var slides = visibleSlides(this.slideshow);
    var style = this.dots.getAttribute('data-oi-dot-style') || 'dot';
    this.dots.innerHTML = '';
    if (slides.length < 2) return;
    for (var i = 0; i < slides.length; i++) {
      var id = slides[i].getAttribute('data-media-id');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oi-gnav__dot';
      b.setAttribute('data-oi-dot-for', id);
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      if (style === 'number') b.textContent = String(i + 1);
      b.addEventListener('click', function () {
        selectMedia(self.slideshow, this.getAttribute('data-oi-dot-for'));
      });
      this.dots.appendChild(b);
    }
  };

  Gallery.prototype.sync = function () {
    var slides = visibleSlides(this.slideshow);
    if (!slides.length) return;
    var id = slides[currentIndex(slides)].getAttribute('data-media-id');

    if (this.dots) {
      var dots = this.dots.querySelectorAll('[data-oi-dot-for]');
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', dots[i].getAttribute('data-oi-dot-for') === id ? 'true' : 'false');
      }
    }

    if (this.caption) {
      var items = this.caption.querySelectorAll('[data-oi-cap-for]');
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-on', items[j].getAttribute('data-oi-cap-for') === id);
      }
    }
  };

  // Les flèches sont posées sur le cadre de la galerie, qui contient aussi les
  // vignettes : on les centre sur les images seules, pas sur l'ensemble.
  Gallery.prototype.placeArrows = function () {
    var grid = this.slideshow;
    if (!grid || !grid.offsetHeight) return;
    var top = grid.offsetTop + grid.offsetHeight / 2;
    this.root.style.setProperty('--OI-GNAV-TOP', Math.round(top) + 'px');
  };

  Gallery.prototype.watch = function () {
    var self = this;
    var pending = null;
    function soon() {
      if (pending) window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        pending = null;
        self.sync();
        self.placeArrows();
      }, 60);
    }
    new MutationObserver(soon).observe(this.slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        self.placeArrows();
      });
      ro.observe(this.slideshow);
    }
    window.addEventListener('resize', soon);
    // le thème peut reconstruire les diapositives au changement de variante
    this.slideshow.addEventListener('theme:image:change', soon);
  };

  /* ------------------------------------------------- icônes SVG à recolorer */

  /* Une icône SVG importée peut être recolorée sans que le marchand ait à
     connaître ses couleurs d'origine : on relève les couleurs présentes dans
     l'ordre où elles apparaissent, et on remplace la 1re, la 2e, la 3e par
     celles choisies dans le thème. */
  var OI_COLOR_RE = /#[0-9a-fA-F]{3,8}\b|rgba?\(\s*[\d.%\s,\/]+\)/g;
  var OI_PROPS = ['fill', 'stroke', 'stop-color'];

  /* Deux ecritures du meme rouge doivent compter pour une seule couleur :
     on ramene tout a une forme comparable avant de constituer les emplacements. */
  function normColor(value) {
    if (!value) return '';
    value = String(value).trim().toLowerCase().replace(/\s+/g, '');
    if (/^#[0-9a-f]{3}$/.test(value)) {
      value = '#' + value[1] + value[1] + value[2] + value[2] + value[3] + value[3];
    }
    if (/^#[0-9a-f]{8}$/.test(value) && value.slice(-2) === 'ff') value = value.slice(0, 7);
    return value;
  }

  function isPaint(value) {
    var v = normColor(value);
    if (!v) return false;
    if (v === 'none' || v === 'transparent' || v === 'currentcolor' || v === 'inherit') return false;
    return true;
  }

  /* Remplace, dans une chaine quelconque (attribut style, feuille <style>
     interne), chaque couleur reperee par la couleur choisie a son rang. */
  function swapColors(text, found, slots) {
    return text.replace(OI_COLOR_RE, function (tok) {
      var idx = found.indexOf(normColor(tok));
      if (idx < 0) return tok;
      return slots[idx] || tok;
    });
  }

  /* Une icone SVG importee peut etre recoloree sans que le marchand ait a
     connaitre ses couleurs d'origine : on releve les couleurs presentes dans
     l'ordre ou elles apparaissent, et on remplace la 1re, la 2e, la 3e par
     celles choisies dans le theme.

     Trois ecritures cohabitent dans les SVG du commerce, il faut les couvrir
     toutes les trois, sinon la couleur "ne bouge pas" :
       - l'attribut     <path fill="#D65461">
       - le style en dur <path style="fill:#D65461">
       - la classe CSS   <style>.a{fill:#D65461}</style>
     Le style en dur l'emporte sur l'attribut : on ecrit donc toujours dans la
     propriete de style quand elle existe, pas seulement dans l'attribut. */
  function recolorSvg(host) {
    var raw = host.getAttribute('data-oi-svg-colors') || '';
    var slots = raw.split('|').filter(function (s) { return s !== ''; });
    var svg = host.querySelector('svg');
    if (!svg || !slots.length) return;

    var found = [];
    function noteColor(value) {
      if (!isPaint(value)) return;
      var v = normColor(value);
      if (found.indexOf(v) === -1) found.push(v);
    }

    var styleTags = svg.querySelectorAll('style');
    var s, i, p, node, tok;

    // 1. les couleurs declarees en CSS interne, dans l'ordre de la feuille
    for (s = 0; s < styleTags.length; s++) {
      var decls = styleTags[s].textContent.match(OI_COLOR_RE) || [];
      for (i = 0; i < decls.length; i++) noteColor(decls[i]);
    }

    // 2. puis celles portees par les elements, dans l'ordre du document
    var nodes = svg.querySelectorAll('*');
    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (node.tagName && node.tagName.toLowerCase() === 'style') continue;
      for (p = 0; p < OI_PROPS.length; p++) {
        noteColor(node.getAttribute(OI_PROPS[p]));
        if (node.style) noteColor(node.style.getPropertyValue(OI_PROPS[p]));
      }
      var inline = node.getAttribute('style');
      if (inline) {
        var toks = inline.match(OI_COLOR_RE) || [];
        for (var t = 0; t < toks.length; t++) noteColor(toks[t]);
      }
    }

    // un SVG sans couleur declaree est noir par defaut : on lui donne un rang
    var defaultSlot = false;
    if (!found.length) {
      defaultSlot = true;
      found.push('__default__');
    }

    // 3. application
    for (s = 0; s < styleTags.length; s++) {
      styleTags[s].textContent = swapColors(styleTags[s].textContent, found, slots);
    }

    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (node.tagName && node.tagName.toLowerCase() === 'style') continue;

      var inlineAttr = node.getAttribute('style');
      if (inlineAttr) {
        var swapped = swapColors(inlineAttr, found, slots);
        if (swapped !== inlineAttr) node.setAttribute('style', swapped);
      }

      for (p = 0; p < OI_PROPS.length; p++) {
        var attr = OI_PROPS[p];
        var cur = node.getAttribute(attr);
        var idx = -1;
        if (isPaint(cur)) {
          idx = found.indexOf(normColor(cur));
        } else if (!cur && attr === 'fill' && defaultSlot) {
          idx = 0;
        }
        if (idx < 0) continue;
        var color = slots[idx];
        if (!color) continue;
        node.setAttribute(attr, color);
        // le style en dur gagne contre l'attribut : on le realigne
        if (node.style && node.style.getPropertyValue(attr)) {
          node.style.setProperty(attr, color);
        }
      }
    }

    svg.removeAttribute('width');
    svg.removeAttribute('height');
    if (!svg.getAttribute('preserveAspectRatio')) {
      svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    }
  }

  /* Un SVG importe dans Contenu > Fichiers arrive dans un <img> : le navigateur
     ne laisse alors rien toucher a son contenu. On va donc chercher le fichier
     (le CDN Shopify l'autorise) et on le pose en clair dans la page, ce qui le
     rend recolorable comme un SVG colle a la main. Si ca echoue, l'image reste
     affichee telle quelle : on ne perd jamais l'etiquette. */
  var oiSvgCache = {};
  function inlineSvgFromSrc(host) {
    var src = host.getAttribute('data-oi-svg-src');
    if (!src || !window.fetch) return;

    function place(text) {
      if (!text || text.indexOf('<svg') === -1) return;
      var doc;
      try {
        doc = new DOMParser().parseFromString(text, 'image/svg+xml');
      } catch (e) { return; }
      var svg = doc && doc.querySelector('svg');
      if (!svg || doc.querySelector('parsererror')) return;
      host.innerHTML = '';
      host.appendChild(document.importNode(svg, true));
      recolorSvg(host);
    }

    if (oiSvgCache[src]) {
      oiSvgCache[src].then(place);
      return;
    }
    oiSvgCache[src] = fetch(src, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
    oiSvgCache[src].then(place);
  }

  function initSvgHosts(scope) {
    var hosts = (scope || document).querySelectorAll('[data-oi-svg-colors]:not([data-oi-svg-done])');
    for (var i = 0; i < hosts.length; i++) {
      hosts[i].setAttribute('data-oi-svg-done', '');
      if (hosts[i].getAttribute('data-oi-svg-src') && !hosts[i].querySelector('svg')) {
        inlineSvgFromSrc(hosts[i]);
      } else {
        recolorSvg(hosts[i]);
      }
    }
  }

  /* --------------------------------------------------- pilules défilantes */

  /* Le ruban ne défile que s'il déborde : sinon les pilules restent tranquilles,
     centrées, et on évite un mouvement inutile sur une seule pilule. */
  function initMarquee(scope) {
    var rails = (scope || document).querySelectorAll('[data-oi-marquee]:not([data-oi-marquee-done])');
    for (var i = 0; i < rails.length; i++) {
      (function (rail) {
        rail.setAttribute('data-oi-marquee-done', '');
        var track = rail.querySelector('[data-oi-marquee-track]');
        if (!track) return;

        function apply() {
          var overflows = track.scrollWidth > rail.clientWidth + 2;
          rail.classList.toggle('is-scrolling', overflows);
          if (!overflows) {
            track.style.removeProperty('--OI-MARQUEE-DURATION');
            return;
          }
          if (!rail.hasAttribute('data-oi-marquee-cloned')) {
            rail.setAttribute('data-oi-marquee-cloned', '');
            var copy = track.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-oi-marquee-track');
            track.parentNode.appendChild(copy);
          }
          var speed = parseFloat(rail.getAttribute('data-oi-marquee-speed')) || 40; // px/s
          var duration = track.scrollWidth / speed;
          rail.style.setProperty('--OI-MARQUEE-DURATION', duration.toFixed(2) + 's');
        }

        apply();
        if (window.ResizeObserver) new ResizeObserver(apply).observe(rail);
        window.addEventListener('resize', apply);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(apply);
      })(rails[i]);
    }
  }

  /* ------------------------------------- code promo : placement libre (CSS) */
  /* L'éditeur de thème peut viser une zone quelconque de la page par son
     sélecteur CSS (bloc d'application, section précise...). Liquid rend alors
     le bouton en fin de colonne produit, masqué, dans un porteur que l'on
     déplace ici. Les blocs d'application peuvent arriver après nous : on
     réessaie quelques fois avant de renoncer. */

  var OI_OCP_RETRIES = [200, 600, 1500, 3000];

  function ocpPlace(node) {
    var sel = (node.getAttribute('data-ocp-selector') || '').trim();
    if (!sel) return false;
    var target;
    try {
      target = document.querySelector(sel);
    } catch (e) {
      return false; // sélecteur invalide : on laissera le filet de sécurité jouer
    }
    if (!target || target === node || target.contains(node) || node.contains(target)) return false;

    var where = node.getAttribute('data-ocp-where') || 'before';
    if (where === 'top') {
      target.insertBefore(node, target.firstChild);
    } else if (where === 'bottom') {
      target.appendChild(node);
    } else if (where === 'after') {
      if (!target.parentNode) return false;
      target.parentNode.insertBefore(node, target.nextSibling);
    } else {
      if (!target.parentNode) return false;
      target.parentNode.insertBefore(node, target);
    }
    node.hidden = false;
    return true;
  }

  function ocpGiveUp(node) {
    if (node.getAttribute('data-ocp-keep') === '1') {
      node.hidden = false; // filet de sécurité : il reste en fin de colonne
    } else if (node.parentNode) {
      node.parentNode.removeChild(node);
    }
  }

  function initOcpMove(scope) {
    var fresh = (scope || document).querySelectorAll('[data-ocp-move]:not([data-ocp-move-done])');
    for (var i = 0; i < fresh.length; i++) {
      (function (node) {
        node.setAttribute('data-ocp-move-done', '');

        /* Re-rendu d'une section dans l'éditeur : le porteur précédent vit
           désormais hors de la section, il faut le retirer nous-mêmes. */
        var id = node.getAttribute('data-ocp-move');
        if (id) {
          var olds = document.querySelectorAll('[data-ocp-move="' + id + '"][data-ocp-move-done]');
          for (var j = 0; j < olds.length; j++) {
            if (olds[j] !== node && olds[j].parentNode) olds[j].parentNode.removeChild(olds[j]);
          }
        }

        var step = 0;
        function attempt() {
          if (!node.isConnected) return;
          if (ocpPlace(node)) return;
          if (step < OI_OCP_RETRIES.length) {
            setTimeout(attempt, OI_OCP_RETRIES[step]);
            step++;
          } else {
            ocpGiveUp(node);
          }
        }
        attempt();
      })(fresh[i]);
    }
  }

  /* ------------------------------------------------------------- démarrage */

  function initIn(scope) {
    var galleries = (scope || document).querySelectorAll('[data-oi-gallery]:not([data-oi-gallery-done])');
    for (var i = 0; i < galleries.length; i++) {
      galleries[i].setAttribute('data-oi-gallery-done', '');
      new Gallery(galleries[i]);
    }
    initSvgHosts(scope);
    initMarquee(scope);
    initOcpMove(scope);
  }

  function boot() {
    initIn(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initIn(event.target);
  });
})();
